import {Settings, PluginNames, ResponseCodes, Selectors} from "../Settings";
import Locallang from "../Locallang";
import AjaxUtility from "../../../../../../ig_template/Resources/Public/Src/Js/Utility/AjaxUtility";

export default class BookingDatepicker {
	constructor(container) {
		this.languageKey = 'de';
		this.ajaxTypeNum = Settings.AJAX_TYPE_NUM;

		this.container = container;
		this.changeMonthButtons = this.container.querySelectorAll('[data-changemonth]');
		this.datepicker = container.querySelector(Selectors.DATEPICKER);
		this.datepickerDays = this.datepicker.querySelector(Selectors.DATEPICKER_DAYS);
		this.appointments = container.querySelector(Selectors.APPOINTMENTS);
		this.bookingForm = container.querySelector(Selectors.BOOKING_FORM);
		this.bookingDateInput = container.querySelector(Selectors.BOOKING_DATE_INPUT);
		this.bookingDateEndInput = container.querySelector(Selectors.BOOKING_DATE_END_INPUT);

		this.propElements = Object.entries(this.container.querySelectorAll('[data-prop]'));
		this.conditionalElements = Object.entries(this.container.querySelectorAll('[data-if]'));

		this.bindHandlers();
		this.initialiseComponentState();
	}

	initialiseComponentState() {
		this.data = {};

		const currentDate = new Date(),
			sameDayBooking = parseInt(this.container.dataset.samedaybooking) === 1,
			date = this.getStartDate(sameDayBooking),
			formData = this.getFormData(),
			maxDays = parseInt(this.container.dataset.days);

		currentDate.setHours(0, 0, 0, 0);

		this.setData({
			loading: false,
			creatingBooking: false,
			showBookingForm: true,
			showBookingError: false,
			showEmailDoubleBookingError: false,
			showBookingSuccess: false,
			showNoAppointmentSelectedError: false,
			openingHours: null,
			bookings: null,
			// all datepicker cells/days
			dateCells: {},
			currentDate,
			// currently displayed date (first of that month)
			date,
			// user selected date on picker
			selectedDate: null,
			selectedDateFormatted: "",
			selectedAppointment: null,
			club: parseInt(formData.club),
			lucyCalendar: parseInt(formData.lucyCalendar),
			maxDays,
			appointmentDuration: parseInt(this.container.dataset.appointmentduration) * 60000,
			firstAppointmentHour: parseInt(this.container.dataset.firstappointmenthour),
			lastAppointmentHour: parseInt(this.container.dataset.lastappointmenthour),
			appointmentsPerSlot: parseInt(this.container.dataset.appointmentsperslot),
			sameDayBooking,
			minTimeToSameDayBooking: parseInt(this.container.dataset.mintimetosamedaybooking),
			bookingStartDate: parseInt(this.container.dataset.bookingstartdate) ? new Date(parseInt(this.container.dataset.bookingstartdate) * 1000) : false,
			exceptionalOpeningTimes: JSON.parse(this.container.dataset.exceptionalopeningtimes) || [],
			endDate: this.getEndDate(maxDays),
			currentMonth: currentDate.getMonth(),
			currentYear: currentDate.getFullYear(),
			currentDay: currentDate.getDate(),
			year: date.getFullYear(),
			month: date.getMonth(),
			day: date.getDate(),
			monthName: this.ll('monthName', date.getMonth())
		});

		this.getOpeningHours();
		this.getBookings(date)
	}

	bindHandlers() {
		for (const button of this.changeMonthButtons) {
			button.addEventListener('click', () => this.changeMonth(parseInt(button.dataset.changemonth)))
		}

		this.bookingForm.addEventListener('submit', e => this.createBooking(e));
	}

	getFormData(fullIdentifier = false) {
		return $(this.bookingForm).serializeArray().reduce((carry, formValue) => {
			const identifiers = formValue.name.match(/\[(.*?)]/g);
			if ((fullIdentifier || identifiers[0] === "[newBooking]") && formValue.value) {
				const key = fullIdentifier ? formValue.name.replace(/\[]]$/, '][]') : identifiers[1].replace(/[\[\]]/g, ''),
					value = formValue.value;

				if (formValue.name.match(/\[]/)) {
					// formValue is array
					if (!carry.hasOwnProperty(key)) {
						carry[key] = [];
					}
					carry[key].push(value);
					return carry;
				}

				carry[key] = value;
				return carry;
			}

			return carry;
		}, {});
	}

	/**
	 * change the currently displayed month
	 * @param changeBy
	 */
	changeMonth(changeBy) {
		const newDate = new Date(this.data.date.getTime());
		newDate.setMonth(newDate.getMonth() + changeBy);

		const changingToCurrentMonth = newDate.getMonth() === this.data.currentMonth && newDate.getFullYear() === this.data.currentYear;

		if (
			// do not display past months
			((this.isCurrentMonth() || (changingToCurrentMonth && this.isLastDayOfCurrentMonth() && !this.data.sameDayBooking)) && changeBy < 0) ||
			// do not display months past the max booking time
			(this.data.endDate.getTime() <= newDate.getTime())
		) {
			return;
		}

		this.data.date.setMonth(this.data.date.getMonth() + changeBy);
		this.setData({
			month: this.data.date.getMonth(),
			monthName: this.ll('monthName', this.data.date.getMonth()),
			year: this.data.date.getFullYear(),
			day: this.data.date.getDate()
		});
		this.getBookings(this.data.date);
		this.updateComponent();
	}

	/**
	 * Booking form submitted, create booking on server
	 * @param e
	 */
	createBooking(e) {
		e.preventDefault();
		if (this.data.creatingBooking) return;

		const formData = this.getFormData(true);

		if (this.data.selectedAppointment && formData.hasOwnProperty('tx_igtrialbooking_booking[date]')) {
			this.setData({
				creatingBooking: true
			});

			AjaxUtility.request(this.ajaxTypeNum, {action: 'create', ...formData}, {}, this.bookingForm.action)
				.done(response => {
					if (response) {
						if(response.blockSlot) {
							this.addBooking(new Date(response.booking.date), this.data.appointmentsPerSlot);
						}
						this.setData({
							creatingBooking: false,
							showBookingForm: false,
							showBookingSuccess: response.status === ResponseCodes.BOOKING_CREATED,
							showBookingError: response.status === ResponseCodes.BOOKING_BLOCKED,
							showEmailDoubleBookingError: response.status === ResponseCodes.EMAIL_ALREADY_BOOKED
						});

						if (response.status === ResponseCodes.BOOKING_BLOCKED) {
							this.getBookings(this.data.date);
						}
					}
				});
		} else {
			this.setData({
				showNoAppointmentSelectedError: true
			});
		}
	}

	/**
	 * Set Booking Data and update component accordingly
	 * @param {Date} date
	 * @param {int} count
	 */
	addBooking(date, count = 1) {
		const bookings = this.data.bookings;

		if (!bookings.hasOwnProperty(date.getDate())) {
			bookings[date.getDate()] = {
				closedAppointments: 0
			};
		}

		if(!bookings[date.getDate()].hasOwnProperty(date.getTime())) {
			bookings[date.getDate()][date.getTime()] = {
				date,
				count: 0
			}
		}

		bookings[date.getDate()][date.getTime()].count += count;

		if(bookings[date.getDate()][date.getTime()].count >= this.data.appointmentsPerSlot) {
			bookings[date.getDate()].closedAppointments++;
		}

		// update tooltip
		let tooltip = this.data.dateCells[date.getDate()].getElementsByTagName('span')[0],
			appointments = this.data.openingHours[date.getDay()].appointments - bookings[date.getDate()].closedAppointments;

		// remove appointments that may not be booked on the same day
		if(date.toDateString() === this.data.currentDate.toDateString()) {
			appointments -= this.getUnavailableAppointmentsForSameDayBooking();
		}

		tooltip.innerHTML = this.getAppointmentsTooltip(appointments);

		this.setData({bookings});
		if (this.data.selectedDate) {
			this.showAppointmentsForDay(this.data.selectedDate.getDate(), this.data.selectedDate.getDay());
		}
	}

	/**
	 * Rerender component on current data set
	 * this is the core rendering method for this component
	 */
	updateComponent() {
		if (!this.data.loading && this.data.openingHours && this.data.bookings) {
			this.buildDatepicker();

			if (!this.data.selectedDate) {
				this.selectFirstBookableDay();
			}
		}

		for (const button of this.changeMonthButtons) {
			let changeBy = parseInt(button.dataset.changemonth),
				newDate = new Date(this.data.date.getTime());

			newDate.setMonth(newDate.getMonth() + changeBy);

			const changingToCurrentMonth = newDate.getMonth() === this.data.currentMonth && newDate.getFullYear() === this.data.currentYear;

			if (
				// do not display past months
				((this.isCurrentMonth() || (changingToCurrentMonth && this.isLastDayOfCurrentMonth() && !this.data.sameDayBooking)) && changeBy < 0) ||
				// do not display months past the max booking time
				(this.data.endDate.getTime() <= newDate.getTime())
			) {
				button.classList.add('disabled');
			} else {
				button.classList.remove('disabled');
			}
		}
	}

	/**
	 * Set component data and update linked displays
	 * all updates to the internal store (data property) should be handled through this method
	 * @param data
	 */
	setData(data) {
		this.data = Object.assign(this.data, data);
		this.updateData();
	}

	/**
	 * Set component data in linked html elements
	 * automatically updates relevant data in DOM
	 */
	updateData() {
		for (const [key, element] of this.propElements) {
			element.innerText = this.data[element.dataset.prop];
		}

		for (const [key, element] of this.conditionalElements) {
			element.style.display = this.data[element.dataset.if] ? "" : "none";
		}
	}

	/**
	 * Build table layout for a single month in our datepicker
	 */
	buildDatepicker() {
		this.datepickerDays.innerHTML = '';
		this.data.dateCells = {};

		// the first monday that will be displayed on the picker (might negative value if monday is in past month)
		let date = this.firstDayOfSelectedMonth(),
			dayInMonth = date.getDay() === 0 ? -5 : date.getDay() - ((date.getDay() - 1) * 2),
			totalDays = this.daysInSelectedMonth(),
			row = document.createElement('tr');

		for (let day = dayInMonth, dayIndex = 1; day <= totalDays; day++) {
			let cell = document.createElement('td'),
				tooltip = document.createElement('span');

			if (day > 0) {
				cell.innerText = day.toString();

				if (this.isCurrentMonth() && day === this.data.currentDay) {
					cell.classList.add('current');
				}

				if (
					this.data.selectedDate &&
					this.data.selectedDate.getMonth() === this.data.date.getMonth() &&
					this.data.selectedDate.getDate() === day
				) {
					cell.classList.add('selected');
				}

				// is bookable day
				if (this.isBookableDay(date)) {
					const exceptionalOpeningTime = this.getExceptionalOpeningTimeForDate(date),
						dayOfWeek = this.getOpeningHoursDayIndex(date);

					// get max available appointments for this day from the opening times
					let appointments = exceptionalOpeningTime ? exceptionalOpeningTime.appointments : this.data.openingHours[dayOfWeek].appointments;
					if (this.data.bookings.hasOwnProperty(day)) {
						// subtract all previously made bookings from total available appointments on this day
						appointments -= this.data.bookings[day].closedAppointments;
					}

					// remove appointments that may not be booked on the same day
					if(date.toDateString() === this.data.currentDate.toDateString()) {
						appointments -= this.getUnavailableAppointmentsForSameDayBooking();
					}

					tooltip.innerHTML = this.getAppointmentsTooltip(appointments);
					cell.appendChild(tooltip);
					cell.addEventListener('click', () => this.selectDay(day, dayOfWeek));
				} else {
					cell.classList.add('disabled');
				}
				this.data.dateCells[day] = cell;

				date.setDate(date.getDate() + 1);
			} else {
				cell.classList.add('filler');
			}

			row.appendChild(cell);
			dayIndex++;

			if (dayIndex === 8 || day === totalDays) {
				this.datepickerDays.appendChild(row);
				row = document.createElement('tr');
				dayIndex = 1;
			}
		}
	}

	/**
	 * Selects the given day and displays appointments
	 * @param day
	 * @param dayIndex
	 */
	selectDay(day, dayIndex) {
		const selectedDate = new Date();
		selectedDate.setFullYear(this.data.year, this.data.month, day);

		if (this.data.selectedDate && this.data.dateCells.hasOwnProperty(this.data.selectedDate.getDate())) {
			this.data.dateCells[this.data.selectedDate.getDate()].classList.remove('selected');
		}

		this.setData({
			selectedDate: selectedDate,
			selectedDateFormatted: selectedDate.toLocaleDateString([], {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric'
			}),
			selectedAppointment: null
		});

		if (this.data.dateCells.hasOwnProperty(day)) {
			this.data.dateCells[day].classList.add('selected');
		}

		this.showAppointmentsForDay(day, dayIndex);
	}

	/**
	 * Find and select the first bookable day
	 */
	selectFirstBookableDay() {
		const date = new Date();
		if(!this.data.sameDayBooking) {
			date.setHours(0, 0, 0, 0);
		}

		let day = 0;
		while (day < this.data.maxDays) {
			if (this.isBookableDay(date)) {
				this.selectDay(date.getDate(), this.getOpeningHoursDayIndex(date));
				return;
			}

			date.setDate(date.getDate() + 1);
			day++;
		}
	}

	/**
	 * Shows list of available appointments for given day
	 * @param day
	 * @param dayIndex
	 */
	showAppointmentsForDay(day, dayIndex) {
		this.appointments.innerHTML = '';

		// use exceptional opening hours if available
		const openingHours = this.getExceptionalOpeningTimeForDate(this.data.selectedDate) || this.data.openingHours[dayIndex],
			bookings = this.getBookingsComparisonArray(day),
			currentTime = new Date(),
			sameDayCutoffTime = new Date();

		sameDayCutoffTime.setTime(0);
		sameDayCutoffTime.setHours(
			currentTime.getHours(),
			currentTime.getMinutes(),
			currentTime.getSeconds(),
			currentTime.getMilliseconds()
		);
		sameDayCutoffTime.setTime(sameDayCutoffTime.getTime() + this.data.minTimeToSameDayBooking * 60000);

		for (let hours of openingHours.hours) {
			const time = this.getFirstAppointmentTimeForOpeningHours(hours, openingHours.isExceptionalOpeningTime),
				lastAppointmentTime = this.getLastAppointmentTimeForOpeningHours(hours, openingHours.isExceptionalOpeningTime);

			while (time.getTime() <= lastAppointmentTime) {
				const appointmentDate = new Date(this.data.selectedDate.getTime());
				appointmentDate.setHours(time.getHours(), time.getMinutes(), 0, 0);

				let appointment = document.createElement('button');
				appointment.innerText = time.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});

				if (
					bookings.includes(time.getTime()) ||
					(this.isCurrentDate() && time.getTime() < sameDayCutoffTime.getTime())
				) {
					appointment.setAttribute('disabled', 'disabled');
					appointment.classList.add('disabled');
				} else {
					appointment.addEventListener('click', e => this.selectAppointment(e, appointmentDate));
				}

				this.appointments.appendChild(appointment);

				time.setTime(time.getTime() + this.data.appointmentDuration);
			}
		}
	}

	getFirstAppointmentTimeForOpeningHours(hours, isExceptionalOpeningTime) {
		if(isExceptionalOpeningTime) {
			return new Date(hours.start.getTime());
		}
		return new Date(Math.max(hours.start.getTime(), this.getFirstAppointmentTime().getTime()));
	}

	getLastAppointmentTimeForOpeningHours(hours, isExceptionalOpeningTime) {
		if(isExceptionalOpeningTime) {
			return hours.end.getTime() - (this.data.appointmentDuration - 60000);
		}
		// subtracting one minute because 00:00 is not a valid opening time so it is substituted with 23:59
		return Math.min(hours.end.getTime() - (this.data.appointmentDuration - 60000), this.getDefaultLastAppointmentTime().getTime());
	}

	selectAppointment(e, date) {
		e.preventDefault();

		const end = new Date();
		end.setTime(date.getTime() + this.data.appointmentDuration);

		const appointmentButtons = this.appointments.querySelectorAll('button');
		for (let button of appointmentButtons) {
			button.classList.remove('selected');

			if (button === e.target) {
				button.classList.add('selected');
			}
		}

		this.setData({
			showBookingForm: true,
			showBookingError: false,
			showBookingSuccess: false,
			showEmailDoubleBookingError: false,
			showNoAppointmentSelectedError: false,
			selectedAppointment: date,
			selectedDateFormatted:
				`${date.toLocaleDateString([], {
					year: 'numeric',
					month: 'numeric',
					day: 'numeric',
					hour: 'numeric',
					minute: 'numeric'
				})} - ${end.toLocaleTimeString([], {hour: 'numeric', minute: 'numeric'})}`
		});

		this.bookingDateInput.value = date.getTime() / 1000;
		this.bookingDateEndInput.value = (date.getTime() + this.data.appointmentDuration) / 1000;
	}

	getUnavailableAppointmentsForSameDayBooking() {
		let appointments = 0;

		const openingHours = this.data.openingHours[this.data.currentDate.getDay()].hours,
			bookings = this.getBookingsComparisonArray(this.data.currentDate.getDate()),
			offsetStart = new Date(),
			currentTime = new Date(),
			firstAppointmentTime = this.getFirstAppointmentTime(),
			defaultLastAppointmentTime = this.getDefaultLastAppointmentTime();

		offsetStart.setTime(0);
		offsetStart.setHours(Math.max(this.data.firstAppointmentHour, currentTime.getHours()), currentTime.getMinutes(), currentTime.getSeconds());
		offsetStart.setTime(offsetStart.getTime() + this.data.minTimeToSameDayBooking * 60000);

		for (const hours of openingHours) {
			const time = new Date(Math.max(hours.start.getTime(), firstAppointmentTime.getTime())),
				// subtracting one minute because 00:00 is not a valid opening time so it is substituted with 23:59
				lastAppointmentTime = Math.min(hours.end.getTime() - (this.data.appointmentDuration - 60000), defaultLastAppointmentTime.getTime());

			while (time.getTime() <= lastAppointmentTime) {
				if(
					time.getTime() < offsetStart.getTime() &&
					!bookings.includes(time.getTime())
				) {
					appointments++;
				}

				time.setTime(time.getTime() + this.data.appointmentDuration);
			}
		}

		return appointments;
	}

	/**
	 * Retrieves opening times data from server
	 * @param club
	 */
	getOpeningHours() {
		this.setData({loading: true});

		const firstAppointmentTime = this.getFirstAppointmentTime(),
			defaultLastAppointmentTime = this.getDefaultLastAppointmentTime();

		defaultLastAppointmentTime.setTime(defaultLastAppointmentTime.getTime() + this.data.appointmentDuration);

		this.dispatch({
			action: 'getOpeningHours',
			club: this.data.club
		}).done(response => {
			const openingHours = {};

			for (let openingHour of response) {
				for (let day of openingHour.openingDays) {
					let dayIndex = parseInt(day) + 1;
					if(dayIndex > 7) {
						// skip holiday opening hours
						continue;
					}
					if(dayIndex === 7) {
						// reset sunday to index 0
						dayIndex = 0;
					}

					if (!openingHours.hasOwnProperty(dayIndex)) {
						openingHours[dayIndex] = {
							hours: [],
							appointments: 0,
							isExceptionalOpeningTime: false
						};
					}

					for (let hours of openingHour.openingTimes) {
						let start = new Date(),
							end = new Date();

						start.setTime(Math.max(hours.start, firstAppointmentTime.getTime()));
						end.setTime(Math.min(hours.end, defaultLastAppointmentTime.getTime()));

						openingHours[dayIndex].hours.push({
							start: start,
							end: end
						});

						openingHours[dayIndex].appointments += Math.round((end - start) / this.data.appointmentDuration);
					}
				}
			}

			const exceptionalOpeningTimes = this.data.exceptionalOpeningTimes.map(exceptionalOpeningTime => {
				const start = new Date(exceptionalOpeningTime.start),
					end = new Date(exceptionalOpeningTime.end);

				return {
					date: {
						start,
						end
					},
					hours: [{
						start: new Date(new Date(exceptionalOpeningTime.start).setFullYear(1970, 0, 1)),
						end: new Date(new Date(exceptionalOpeningTime.end).setFullYear(1970, 0, 1)),
					}],
					appointments: Math.round((end - start) / this.data.appointmentDuration),
					isExceptionalOpeningTime: true
				}
			});

			this.setData({
				openingHours: openingHours,
				exceptionalOpeningTimes,
				loading: false
			});
			this.updateComponent();
		});
	}

	/**
	 * Retrieves booking data from server for given club from given date to end of same month
	 * @param date
	 * @param club
	 */
	getBookings(date) {
		this.setData({loading: true});

		this.dispatch({
			action: 'getBookings',
			date: parseInt(date.getTime() / 1000),
			club: this.data.club,
			lucyCalendar: this.data.lucyCalendar
		}).done(response => {
			const bookings = {};

			for (let booking of response) {
				let date = new Date();
				date.setTime(booking.date);

				if (!bookings.hasOwnProperty(date.getDate())) {
					bookings[date.getDate()] = {
						closedAppointments: 0
					};
				}

				if(!bookings[date.getDate()].hasOwnProperty(date.getTime())) {
					bookings[date.getDate()][date.getTime()] = {
						date,
						count: 0
					};
				}

				bookings[date.getDate()][date.getTime()].count++;

				if(bookings[date.getDate()][date.getTime()].count === this.data.appointmentsPerSlot) {
					bookings[date.getDate()].closedAppointments++;
				}
			}

			this.setData({
				bookings: bookings,
				loading: false
			});
			this.updateComponent();
		});
	}

	getBookingsComparisonArray(day) {
		// used to set timestamps for possible appointment slots
		const bookings = [],
			cmpTime = new Date();

		cmpTime.setTime(0);

		if (this.data.bookings.hasOwnProperty(day)) {
			for (let key in this.data.bookings[day]) {
				if(this.data.bookings[day].hasOwnProperty(key)) {
					const booking = this.data.bookings[day][key];
					if (this.data.appointmentsPerSlot !== 0 && booking.count >= this.data.appointmentsPerSlot) {
						cmpTime.setHours(booking.date.getHours());
						cmpTime.setMinutes(booking.date.getMinutes());
						bookings.push(cmpTime.getTime());
					}
				}
			}
		}

		return bookings;
	}

	getFirstAppointmentTime() {
		const firstAppointmentTime = new Date();

		firstAppointmentTime.setTime(0);
		firstAppointmentTime.setHours(this.data.firstAppointmentHour);

		return firstAppointmentTime;
	}

	getDefaultLastAppointmentTime() {
		const defaultLastAppointmentTime = new Date();

		defaultLastAppointmentTime.setTime(0);
		defaultLastAppointmentTime.setHours(this.data.lastAppointmentHour);
		defaultLastAppointmentTime.setTime(defaultLastAppointmentTime.getTime());

		return defaultLastAppointmentTime;
	}

	dispatch(params) {
		return AjaxUtility.request(this.ajaxTypeNum, params, PluginNames);
	}

	/**
	 * Check if the given date should be bookable
	 * @param {Date} date
	 * @returns {boolean}
	 */
	isBookableDay(date) {
		date.setHours(0, 0, 0, 0);

		const isInDateRange =
			(
				this.data.sameDayBooking && date.getTime() === this.data.currentDate.getTime() ||
				date.getTime() > this.data.currentDate.getTime()
			) && date.getTime() < this.data.endDate.getTime(),
			isAfterBookingStartDate = (!this.data.bookingStartDate || date.getTime() >= this.data.bookingStartDate.getTime()),
			isInOpeningTimes = this.data.openingHours.hasOwnProperty(this.getOpeningHoursDayIndex(date)),
			isInExceptionalOpeningTimes = this.getExceptionalOpeningTimeForDate(date) !== undefined;

		return (
			isInDateRange &&
			isAfterBookingStartDate &&
			(isInOpeningTimes || isInExceptionalOpeningTimes)
		)
	}

	/**
	 *
	 * @param {Date} date
	 */
	getOpeningHoursDayIndex(date) {
		if(date.getDay() > 6) return 0;
		return date.getDay();
	}

	/**
	 * Gets an exceptional opening time for the given date if one exists
	 * @param {Date} date
	 * @returns {*}
	 */
	getExceptionalOpeningTimeForDate(date) {
		return this.data.exceptionalOpeningTimes.find(exceptionalOpeningTime => {
			return exceptionalOpeningTime.date.start.getDate() === date.getDate() &&
				exceptionalOpeningTime.date.start.getMonth() === date.getMonth() &&
				exceptionalOpeningTime.date.start.getFullYear() === date.getFullYear();
		});
	}

	/**
	 * Check if the datepicker is displaying a month in the current year
	 * @returns {boolean}
	 */
	isCurrentYear() {
		return this.data.year === this.data.currentYear;
	}

	/**
	 * Check if the datepicker is displaying the current month
	 * @returns {boolean}
	 */
	isCurrentMonth() {
		return this.isCurrentYear() && this.data.month === this.data.currentMonth;
	}

	/**
	 * Check if the current date is selected
	 * @returns {boolean|boolean}
	 */
	isCurrentDate() {
		return this.isCurrentMonth() && this.data.selectedDate.getDate() === this.data.currentDay;
	}

	/**
	 * Check if today is the last day of the current month
	 * @returns {boolean}
	 */
	isLastDayOfCurrentMonth() {
		const date = new Date();
		date.setDate(date.getDate() + 1);
		return date.getMonth() !== this.data.currentMonth;
	}

	/**
	 * Get total days of currently displayed month
	 * @returns {number}
	 */
	daysInSelectedMonth() {
		return new Date(this.data.year, this.data.month + 1, 0).getDate();
	}

	/**
	 * Get first weekday index of currently displayed month
	 * @returns {Date}
	 */
	firstDayOfSelectedMonth() {
		return new Date(this.data.year, this.data.month, 1);
	}

	/**
	 * Get string translation from locallang file
	 * @param key
	 * @param index
	 * @returns {*}
	 */
	ll(key, index) {
		if (index !== undefined) {
			return Locallang[this.languageKey][key][index];
		}
		return Locallang[this.languageKey][key];
	}

	/**
	 * Gets date to start datepicker at; first of current month, unless it is currently the last day of the month
	 * @param {boolean} sameDayBooking
	 * @returns {Date}
	 */
	getStartDate(sameDayBooking) {
		const datePickerStartDate = new Date();
		if(!sameDayBooking) {
			// adding one day to current date in order to flip over to next month on last day of current month
			datePickerStartDate.setDate(datePickerStartDate.getDate() + 1);
		}
		datePickerStartDate.setDate(1);
		datePickerStartDate.setHours(0, 0, 0);
		return datePickerStartDate;
	}

	/**
	 * Gets date to end datepicker at using max bookable date range
	 * @param maxDays
	 * @returns {Date}
	 */
	getEndDate(maxDays) {
		const datePickerEndDate = new Date();
		datePickerEndDate.setDate(datePickerEndDate.getDate() + maxDays);
		datePickerEndDate.setHours(0, 0, 0);
		return datePickerEndDate;
	}

	getAppointmentsTooltip(appointments) {
		return `${appointments}&nbsp; freie Termine`;
	}
}
